export default function matchSearchString(
  str: string,
  target: string
): Array<{ match: boolean; content: string }> {
  return str
    .split(target)
    .flatMap((str, i) => {
      if (i !== 0) {
        return [
          { match: true, content: target },
          { match: false, content: str },
        ];
      }

      return [{ match: false, content: str }];
    })
    .filter(({ content }) => !!content);
}
